import React, { useEffect, useState } from "react";

// Dependencies
import axios from "axios";

// Gallery
const Gallery = () => {
  // States
  const [pageNo, setPageNo] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const [type, setType] = useState("");
  const [character, setCharacter] = useState("");
  const [background, setBackground] = useState("");
  const [clothingHero, setClothingHero] = useState("");
  const [clothingNormal, setClothingNormal] = useState("");
  const [effect, setEffect] = useState("");
  const [hairOrShield, setHairOrShield] = useState("");
  const [mask, setMask] = useState("");
  const [weapon, setWeapon] = useState("");

  const [nfts, setNFTs] = useState([]);

  // Fetch NFTs
  useEffect(() => {
    axios
      .get(
        // `../../collection/filter?character=${character}&background=${background}&clothing_hero=${clothingHero}&clothing_normal=${clothingNormal}&effect=${effect}&hair_or_shield=${hairOrShield}&mask=${mask}&weapon=${weapon}&limit=9&page=${pageNo}`
        `https://maxform.link/herocard/collection/filter.php?character=${character}&background=${background}&clothing_hero=${clothingHero}&clothing_normal=${clothingNormal}&effect=${effect}&hair_or_shield=${hairOrShield}&mask=${mask}&weapon=${weapon}&limit=9&page=${pageNo}`
      )
      .then((res) => {
        setNFTs([]);
        setTotalPage(res.data.total_page);
        setNFTs(res.data.nfts);
      });
  }, [pageNo]);

  useEffect(() => {
    axios
      .get(
        // `../../collection/filter?character=${character}&background=${background}&clothing_hero=${clothingHero}&clothing_normal=${clothingNormal}&effect=${effect}&hair_or_shield=${hairOrShield}&mask=${mask}&weapon=${weapon}&limit=9&page=1`
        `https://maxform.link/herocard/collection/filter.php?character=${character}&background=${background}&clothing_hero=${clothingHero}&clothing_normal=${clothingNormal}&effect=${effect}&hair_or_shield=${hairOrShield}&mask=${mask}&weapon=${weapon}&limit=9&page=1`
      )
      .then((res) => {
        setNFTs([]);
        setPageNo(1);
        setTotalPage(res.data.total_page);
        setNFTs(res.data.nfts);
      });
  }, [
    character,
    background,
    clothingHero,
    clothingNormal,
    effect,
    hairOrShield,
    mask,
    weapon,
  ]);

  return (
    <React.Fragment>
      <main className="gallery-page">
        <section className="hero">
          <div className="container">
            <div className="left-part">
              <h1>
                Gallery <span>//</span>
              </h1>

              <div className="selects">
                {/* Type */}
                <select onChange={(e) => setType(e.target.value)}>
                  <option value="">Type</option>
                  <option value="Supreme">Supreme</option>
                  <option value="Normal">Normal</option>
                </select>

                {/* Character */}
                <select onChange={(e) => setCharacter(e.target.value)}>
                  <option value="">Character</option>
                  <option
                    value="BitLegend"
                    selected={character === "BitLegend"}
                  >
                    BitLegend
                  </option>
                  <option
                    value="Dark Slezenger"
                    selected={character === "Dark Slezenger"}
                  >
                    Dark Slezenger
                  </option>
                  <option
                    value="Super Beast"
                    selected={character === "Super Beast"}
                  >
                    Super Beast
                  </option>
                  <option
                    value="Dr. Zygol"
                    selected={character === "Dr. Zygol"}
                  >
                    Dr. Zygol
                  </option>
                  <option
                    value="Wind Thunder"
                    selected={character === "Wind Thunder"}
                  >
                    Wind Thunder
                  </option>
                </select>

                {/* Background */}
                <select onChange={(e) => setBackground(e.target.value)}>
                  <option value="">Background</option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option value="Hollway">Hollway</option>
                      <option value="Deep City Night">Deep City Night</option>
                      <option value="Space Station">Space Station</option>
                      <option value="Night of Ruins">Night of Ruins</option>
                      <option value="Dungeon">Dungeon</option>
                      <option value="Future Holograms">Future Holograms</option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option value="Future Holograms">Future Holograms</option>
                      <option value="Neon Sign Street">Neon Sign Street</option>
                      <option value="Dungeon">Dungeon</option>
                      <option value="Deep City Night">Deep City Night</option>
                      <option value="Hollway">Hollway</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option value="Neon Sign Street">Neon Sign Street</option>
                      <option value="Dungeon">Dungeon</option>
                      <option value="Night of Ruins">Night of Ruins</option>
                      <option value="Deep City Night">Deep City Night</option>
                      <option value="Referee's Stadium">
                        Referee's Stadium
                      </option>
                      <option value="Space Station">Space Station</option>
                      <option value="A Vast Desert">A Vast Desert</option>
                      <option value="A Secret Lake">A Secret Lake</option>
                      <option value="The Palace of the Night">
                        The Palace of the Night
                      </option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option value="Ancient Palace">Ancient Palace</option>
                      <option value="Dungeon">Dungeon</option>
                      <option value="The Fire in the Forest">
                        The Fire in the Forest
                      </option>
                      <option value="Deep City Night">Deep City Night</option>
                      <option value="A Deep Night's Temple">
                        A Deep Night's Temple
                      </option>
                      <option value="Space Station">Space Station</option>
                      <option value="A Vast Desert">A Vast Desert</option>
                      <option value="A Secret Lake">A Secret Lake</option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option value="Ancient Palace">Ancient Palace</option>
                      <option value="Dungeon">Dungeon</option>
                      <option value="The Fire in the Forest">
                        The Fire in the Forest
                      </option>
                      <option value="Deep City Night">Deep City Night</option>
                      <option value="Night of Ruins">Night of Ruins</option>
                      <option value="Space Station">Space Station</option>
                      <option value="A Vast Desert">A Vast Desert</option>
                      <option value="A Secret Lake">A Secret Lake</option>
                      <option value="The Palce of the Night">
                        The Palce of the Night
                      </option>
                    </React.Fragment>
                  )}
                </select>

                {/* Clothing Hero */}
                <select onChange={(e) => setClothingHero(e.target.value)}>
                  <option value="">Clothing Hero</option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option value="Goblin">Goblin</option>
                      <option value="European War Armor">
                        European War Armor
                      </option>
                      <option value="Prince's Coat">Prince's Coat</option>
                      <option value="Mechanical Armor">Mechanical Armor</option>
                      <option value="Robotic Armor">Robotic Armor</option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option value="Cat">Cat</option>
                      <option value="Hollys">Hollys</option>
                      <option value="Assasin">Assasin</option>
                      <option value="Succubus">Succubus</option>
                      <option value="Mechanic">Mechanic</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option value="Beast Warrior">Beast Warrior</option>
                      <option value="Mechanic Muscle">Mechanic Muscle</option>
                      <option value="Military Armor">Military Armor</option>
                      <option value="Red Bull">Red Bull</option>
                      <option value="Tattoo">Tattoo</option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option value="Skeleton">Skeleton</option>
                      <option value="Black Death Crows">
                        Black Death Crows
                      </option>
                      <option value="Mad Scientist">Mad Scientist</option>
                      <option value="Psychic Death">Psychic Death</option>
                      <option value="Black Wizard">Black Wizard</option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option value="Engel">Engel</option>
                      <option value="Mongolia">Mongolia</option>
                      <option value="Fairy in the Forest">
                        Fairy in the Forest
                      </option>
                      <option value="Demon Hunter">Demon Hunter</option>
                      <option value="Thunder">Thunder</option>
                    </React.Fragment>
                  )}
                </select>

                {/* Clothing Normal */}
                <select onChange={(e) => setClothingNormal(e.target.value)}>
                  <option value="">Clothing Normal</option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option value="Martial Arts">Martial Arts</option>
                      <option value="Riding">Riding</option>
                      <option value="Casual Clothes">Casual Clothes</option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option value="Office">Office</option>
                      <option value="Police">Police</option>
                      <option value="Funky">Funky</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option value="Military Uniform">Military Uniform</option>
                      <option value="Work Clothing">Work Clothing</option>
                      <option value="Yellow Suit">Yellow Suit</option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option value="Wine Suit">Wine Suit</option>
                      <option value="Secret Doctor">Secret Doctor</option>
                      <option value="Red Black Boss">Red Black Boss</option>
                      <option value="Orange Black Boss">
                        Orange Black Boss
                      </option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option value="Black Short Dress">
                        Black Short Dress
                      </option>
                      <option value="Asian Costume">Asian Costume</option>
                      <option value="Sexycute">Sexycute</option>
                    </React.Fragment>
                  )}
                </select>

                {/* Effect */}
                <select onChange={(e) => setEffect(e.target.value)}>
                  <option value="">Effect</option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option value="Effect Green">Effect Green</option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option value="Effect Purple">Effect Purple</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option value="Effect Yellow">Effect Yellow</option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option value="Effect Red">Effect Red</option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option value="Effect Purple">Effect Purple</option>
                    </React.Fragment>
                  )}
                </select>

                {/* Hair or Shield */}
                <select onChange={(e) => setHairOrShield(e.target.value)}>
                  <option value="">
                    {character === "Super Beast" ? "Shield" : "Hair"}
                  </option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option>Warrior Calm Ponytail</option>
                      <option>Shorts Sports Hair</option>
                      <option>Wild Ponytail</option>
                      <option>Prince's Hair</option>
                      <option>Calm Long Hair</option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option>Undo Ponytail</option>
                      <option>Red & Blue Pigtail</option>
                      <option>Goddess Hair</option>
                      <option>Wage Long Hair</option>
                      <option>Bobbed Hair</option>
                      <option>Bronze Long Hair</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option>Falcon Shield</option>
                      <option>Titanum Shield</option>
                      <option>Typhoon Shield</option>
                      <option>No Shield</option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option>Short Bearded Hair</option>
                      <option>Silver Boss Hair</option>
                      <option>Pomade</option>
                      <option>Loose Hair</option>
                      <option>Silver Short Hair</option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option>White Short Hair</option>
                      <option>Asian Undo Ponytail</option>
                      <option>White Straight Hair</option>
                      <option>Black Ponytail with Bangs</option>
                      <option>Bobbed Hair</option>
                    </React.Fragment>
                  )}
                </select>

                {/* Mask */}
                <select onChange={(e) => setMask(e.target.value)}>
                  <option value="">Mask</option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option value="Devil's Mask">Devil's Mask</option>
                      <option value="Goblin's Lower Jaw">
                        Goblin's Lower Jaw
                      </option>
                      <option value="Warrior Mask">Warrior Mask</option>
                      <option value="Mechanical Light Mask">
                        Mechanical Light Mask
                      </option>
                      <option value="Robotic Mask">Robotic Mask</option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option value="Sunglasses">Sunglasses</option>
                      <option value="Darkgreen Eyepatch">
                        Darkgreen Eyepatch
                      </option>
                      <option value="Light Mask">Light Mask</option>
                      <option value="Silk Mask">Silk Mask</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option value="Bear Attack">Bear Attack</option>
                      <option value="Crazy Wolf">Crazy Wolf</option>
                      <option value="Black Panther">Black Panther</option>
                      <option value="Red Wolf">Red Wolf</option>
                      <option value="Lion Roar">Lion Roar</option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option value="Mad Clown">Mad Clown</option>
                      <option value="Phantom">Phantom</option>
                      <option value="Blue Fire Crow">Blue Fire Crow</option>
                      <option value="Skeleton of Demon">
                        Skeleton of Demon
                      </option>
                      <option value="Skeleton of Titanium">
                        Skeleton of Titanium
                      </option>
                      <option value="Skeleton of Red Devil">
                        Skeleton of Red Devil
                      </option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option value="Rabbit Pitching">Rabbit Pitching</option>
                      <option value="Asian Satgat">Asian Satgat</option>
                      <option value="Traditional Cat">Traditional Cat</option>
                      <option value="Blue Demon">Blue Demon</option>
                      <option value="Ray of Light">Ray of Light</option>
                      <option value="Eye Patch">Eye Patch</option>
                    </React.Fragment>
                  )}
                </select>

                {/* Weapon */}
                <select onChange={(e) => setWeapon(e.target.value)}>
                  <option value="">Weapon</option>

                  {character === "BitLegend" && (
                    <React.Fragment>
                      <option value="Arabian Sword">Arabian Sword</option>
                      <option value="Old Red Sword">Old Red Sword</option>
                      <option value="Evil Spirit Sword">
                        Evil Spirit Sword
                      </option>
                      <option value="Flame Sword">Flame Sword</option>
                      <option value="Classic War Sword">
                        Classic War Sword
                      </option>
                    </React.Fragment>
                  )}

                  {character === "Dark Slezenger" && (
                    <React.Fragment>
                      <option value="Double-edged Sword">
                        Double-edged Sword
                      </option>
                      <option value="Light a Whip">Light a Whip</option>
                      <option value="Single Light Sword">
                        Single Light Sword
                      </option>
                      <option value="Dark Platinium Knife">
                        Dark Platinium Knife
                      </option>
                      <option value="Gun">Gun</option>
                    </React.Fragment>
                  )}

                  {character === "Super Beast" && (
                    <React.Fragment>
                      <option value="Crash Fist">Crash Fist</option>
                      <option value="Dragonic Claws">Dragonic Claws</option>
                      <option value="Military Power">Military Power</option>
                      <option value="Legendary Fist">Legendary Fist</option>
                    </React.Fragment>
                  )}

                  {character === "Dr. Zygol" && (
                    <React.Fragment>
                      <option value="Wand of Electric">Wand of Electric</option>
                      <option value="Wand of Fire">Wand of Fire</option>
                      <option value="Wand of Psychic">Wand of Psychic</option>
                      <option value="Wand with Magic Book">
                        Wand with Magic Book
                      </option>
                      <option value="Wand with Blood">Wand with Blood</option>
                    </React.Fragment>
                  )}

                  {character === "Wind Thunder" && (
                    <React.Fragment>
                      <option value="The Bow of a Robot">
                        The Bow of a Robot
                      </option>
                      <option value="The Bow of Fire">The Bow of Fire</option>
                      <option value="The Bow of Engel">The Bow of Engel</option>
                      <option value="The Bow of Demon">The Bow of Demon</option>
                      <option value="The Bow of the Fulture">
                        The Bow of the Fulture
                      </option>
                    </React.Fragment>
                  )}
                </select>

                <p
                  className="reset"
                  onClick={() => {
                    setType("");
                    setCharacter("");
                    setBackground("");
                    setClothingHero("");
                    setClothingNormal("");
                    setEffect("");
                    setHairOrShield("");
                    setMask("");
                    setWeapon("");
                  }}
                >
                  Reset
                </p>

                <div className="btns" style={{ gridTemplateColumns: "1fr" }}>
                  <button
                    className="primary-btn"
                    onClick={() => {
                      window
                        .open(
                          "https://opensea.io/collection/official-maxform",
                          "_blank"
                        )
                        .focus();
                    }}
                  >
                    Opensea
                  </button>

                  {/* <button className="secondary-btn">Binance NFT</button> */}
                </div>
              </div>
            </div>

            <div className="right-part">
              <div className="nfts">
                {nfts.map((nft, index) => {
                  return (
                      <div key={index} className="nft">
                        <img
                            src={`https://maxform.mypinata.cloud/ipfs/${nft.image.replace("ipfs://",
                                ""
                            )}`}
                            alt=""
                        />
                        <h3>{nft.name}</h3>
                      </div>
                  );
                })}
              </div>

              <div className="page-navs">
                {pageNo > 1 && (
                  <button
                    onClick={() => {
                      setPageNo(pageNo - 1);
                    }}
                  >
                    Prev
                  </button>
                )}

                {totalPage > 1 && pageNo < totalPage && (
                  <button
                    onClick={() => {
                      setPageNo(pageNo + 1);
                    }}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default Gallery;
